import '@/lib/i18n/config';
import '@/App.css';
import { AppProvider } from '@/providers/app';

function App() {
  return <AppProvider />;
}

export default App;
